//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const sentenceText_es = `Mi reloj se cayó en el agua.
Resulta difícil respirar.
Puedo ver los anillos de Saturno.
La física y la química son difíciles.
Mi cuenta corriente está en números rojos.
Tenemos espaguetis para comer.
A los elefantes les dan miedo los ratones.
Ese es mi lugar favorito para visitar.
Ten cuidado con los objetos que vuelan a poca altura.
Por favor, facilite su fecha de nacimiento.
Corremos el riesgo de fracasar.
Él es igual que todo el mundo.
El mundo es un escenario.
¿Me estás hablando a mí?
Sí, eres muy inteligente.
La fuerza está contigo.
¿Lo has pasado bien?
El espacio tiene alta prioridad.
Eres un ejemplo maravilloso.
No malgastes el tiempo.
No bebas demasiado.
La música es mejor de lo que suena.
Ven y así ves nuestro coche nuevo.
Voy a clase de música.
Pronto volveremos de la ciudad.
Llevo una chaqueta y una corbata.
Habrá algo de niebla esta noche.
Tengo alergia a las abejas y a los cacahuetes.
Él sigue en nuestro equipo.
Mi capricho preferido es el chocolate.
El rey te envía a la torre.
Somos súbditos y debemos obedecer.
Mamá le hizo a ella un jersey de cuello alto.
Fuimos a hacer la compra.
Hoy es el último día para entregar las tareas.
Lo que ves es lo que recibes.
La tienda cerrará a las diez.
Resulta muy inoportuno.
Esa es una muy buena idea.
Nuestro número de teléfono ha cambiado.
Muchas gracias por tu ayuda.
La biblioteca está cerrada hoy.
María tenía un corderito.
Este reloj es demasiado caro.
El servicio de correos es muy lento.
El otoño es mi estación preferida.
Los zorros son animales muy inteligentes.
Los niños están muy emocionados.
El aparcamiento está lleno de camiones.
Mi bicicleta tiene una rueda pinchada.
No camines demasiado rápido.
Los patos graznan para pedir comida.
El sol sale por el este.
Hace mucho viento hoy.
No te preocupes por esto.
Él llevaba una sudadera.
Te veré al mediodía.
Los niños están jugando fuera.
¿Te gusta ir de compras el domingo?
Derramé el café en la alfombra.
No te bebas el agua.
Mi coche siempre se estropea en invierno.
¿Te gusta acampar?
Los manifestantes bloquearon el tráfico.
El discurso de aceptación fue aburrido.
Trabaja mucho para llegar a la cima.
Una buena broma merece unas buenas risas.
El sindicato irá a la huelga.
Nunca mezcles religión y política.
Las entradas son muy caras.
Una imagen vale más que mil palabras.
Esta cámara hace buenas fotos.
Parece una chabola.
El perro enterró el hueso.
No soy capaz de solucionarlo.
Por favor, siga las instrucciones.
Los aeropuertos son lugares muy transitados.
El bus estaba repleto.
Debería hacer sol mañana.
Un médico te ayudará.
Deberías ir al dentista.
Debes pedir una cita.
Los jugadores deben conocer todas la normas.
¿Te gustaría venir a mi casa?
Febrero tiene un día de más.
No te sientas mal por eso.
La biblioteca tiene muchos libros.
Me gusta jugar al tenis.
Es difícil concentrarse.
Escucho la grabación todos los días.
Él está gritando mucho.
La clavija no entra en el enchufe.
Los fines de semana cenamos fuera.
Se controlaba el agua a diario.
Él observó con asombro.
Había un gran arañazo en la superficie de la mesa.
Los vendedores deben llegar a su cuota mensual de ventas.
Salvar a aquel niño fue un acto heroico.
El granito es la roca más dura.
Tenemos bastante testigos.
Los delfínes saltan muy alta encima del agua.
El sistema de ventilación está roto.
Los dinosaurios han sido extintos para mucho tiempo.
La tesorera debe hacer que cuadren sus cuentas.
Ellos miraron la película entera.`;

export default sentenceText_es;